import i18n from 'i18n/index'

// Titulos de la barra superior segun el diseno: "Users", "Questionnaires" y
// "Protocol Management" en vez de "Participantes", "Generar encuestas" y
// "Detalle del protocolo".
export const USERS_TITLE = i18n.t('usersTitle')
export const USER_PROFILE_TITLE = i18n.t('userProfile')
export const NEWSWALL_TITLE = i18n.t('newsWall')
export const FORM_GENERATOR_TITLE = i18n.t('questionnaires')
export const FORM_GENERATOR_EDITOR_TITLE = FORM_GENERATOR_TITLE
export const FORM_GENERATOR_RESULTS_TITLE = i18n.t('formResults')
export const FORM_GENERATOR_USERS_TITLE = `${FORM_GENERATOR_TITLE} - ${i18n.t('sendForms')}`
export const CONFIGURATION_TITLE = i18n.t('configuration')
export const PATIENTS_FORMS_TITLE = i18n.t('patientsForms')
export const PATIENT_FORM_VIEW_TITLE = i18n.t('form')
export const RESOURCES_TITLE = i18n.t('resources')
export const RESOURCES_SHARED_WITH_ME_TITLE = i18n.t('resourcesSharedWithMe')
export const RESOURCES_NOTIFICATIONS_CONFIG_TITLE = i18n.t('notificationsConfig')
export const ROLE_PERMISSIONS_TITLE = i18n.t('titleRolePermissions')
export const CREATE_PATIENT_TITLE = i18n.t('addPatient')
export const EDIT_PATIENT_TITLE = i18n.t('editPatient')
export const STATISTICS_TITLE = i18n.t('statistics')
export const DASHBOARD_TITLE = i18n.t('dashboard')
export const FORMS_TITLE = i18n.t('forms')
// El diseno deja "Cuestionarios" en la barra superior tambien al crear o
// editar, en vez de repetir ahi el titulo de la pantalla.
export const FORM_GENERATOR_FORM_CREATE_TITLE = FORM_GENERATOR_TITLE
export const FORM_GENERATOR_ASSIGNTO_TITLE = i18n.t('assignFormTo')
export const PRIVACY_POLICY_TITLE = i18n.t('privacyPolicy')
export const COOKIES_POLICY_TITLE = i18n.t('cookiesPolicy')
// En el diseno la barra superior pone "Clinical Protocols" tanto en la lista
// como en el detalle; lo que cambia entre ambas es el titulo de dentro de la
// tarjeta, que en el detalle es "Protocol Management".
export const PROTOCOLS_TITLE = i18n.t('clinicalProtocols')
export const PROTOCOL_DETAIL_TITLE = i18n.t('clinicalProtocols')
